export const consent = {
  title: 'Let’s get ready for your consultation.',
  personalInformation: 'Personal information confirmed.',
  contactDetails: 'Contact details confirmed.',
  submit: 'Next',
  cancelVisitRequest: 'Canceling now will end your visit request.',
  completeSigning: 'To continue your visit, please complete signing the consent form first.',
  successfullyCanceled: 'Your visit has been successfully canceled.',
  actions: {
    returnToSign: 'Return to Sign Consent',
    cancelMyVisit: 'Cancel My Visit',
    done: 'Done',
  },
  errors: {
    failedToCancel: 'Failed to cancel visit',
  },
};
